// companyInfoFields.ts
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
export const userAllFields = [
  {
    id: "name",
    label: "Name",
    placeHolder: "Enter user name",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6
  },
  {
    id: "aka_name",
    label: "Alias Name",
    placeHolder: "Enter alias name",
    type: "text",
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    md: 6
  },
  {
    id: "email",
    label: "E-Mail",
    placeHolder: "Enter email ID",
    type: "text",
    isRequired: true,
    editReadOnly: true,
    inputProps: {
      maxLength: 50,
    },
    md: 6
  },
  {
    id: "phone",
    label: "Phone Number",
    placeHolder: "Enter phone number",
    type: "contact",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
    md: 6
  },
  {
    id: "roles",
    label: "Role",
    placeHolder: "Select",
    type: "multiselect",
    options: [""],
    isRequired: true,
    firstColmd: 4,
    md: 8
  },
  // {
  //   id: "empId",
  //   label: "Employee Code",
  //   placeHolder: "Enter Address",
  //   type: "text",
  // },
  // {
  //   id: "status",
  //   label: "Status",
  //   placeHolder: "Select",
  //   type: "select",
  //   options: ["Active", "Inactive"], // Example options
  // },
];

export const roleAllFields = [
  {
    id: "role",
    label: "Role Name",
    placeHolder: "Enter role name",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    // firstColmd: 4,
    md: 12,

    // editReadOnly:true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    label: "Role Description",
    placeHolder: "Enter description",
    type: "text",

    inputProps: {
      maxLength: 50,
    },
    // firstColmd: 4,
    md: 12,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const feedbackFields = [
  {
    id: "1",
    label: "Q1",
    placeHolder: "Enter Q1",
    type: "textarea",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'
    
  },
  {
    id: "2",
    label: "Q2",
    placeHolder: "Enter Q2",
    type: "textarea",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'
  },
  {
    id: "3",
    label: "Q3",
    placeHolder: "Enter Q3",
    type: "textarea",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'
  },
  {
    id: "4",
    label: "Q4",
    placeHolder: "Enter Q4",
    type: "textarea",
   md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'

  },
  {
    id: "5",
    label: "Q5",
    placeHolder: "Enter Q5",
    type: "textarea",
  md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'
  },
  {
    id: "6",
    label: "Comment",
    placeHolder: "Enter comment",
    type: "textarea",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    textInfo:'(Maximum 250 characters allowed)'
  },
];
